import { BreadcrumbSnapshot } from '../types/BreadcrumbSnapshot';
import { ErrorReportingClient } from '../types/ErrorReportingClient';
import { ErrorReportingDevtools } from '../types/ErrorReportingDevtools';

const MS_PER_SECOND = 1000;

/**
 * Pretty-prints (via `console.table`) and returns the buffered breadcrumb
 * timeline with timestamps normalized to ms-since-now. Optional `filter`
 * matches the breadcrumb category or message (case-insensitive).
 */
export const createListBreadcrumbsDevtool = (
  client: ErrorReportingClient,
): ErrorReportingDevtools['listBreadcrumbs'] => {
  return (filter?: string): BreadcrumbSnapshot[] => {
    const raw = client.getScopeSnapshot().breadcrumbs;

    const now = Date.now() / MS_PER_SECOND;

    const normalized: BreadcrumbSnapshot[] = raw.map((breadcrumb) => ({
      category: breadcrumb.category,
      level: breadcrumb.level,
      message: breadcrumb.message,
      relativeMs: breadcrumb.timestamp
        ? Math.round((now - breadcrumb.timestamp) * MS_PER_SECOND)
        : undefined,
      timestamp: breadcrumb.timestamp,
    }));

    const filtered = filter
      ? normalized.filter((breadcrumb): boolean => {
          const haystack = `${breadcrumb.category ?? ''} ${
            breadcrumb.message ?? ''
          }`.toLowerCase();
          return haystack.includes(filter.toLowerCase());
        })
      : normalized;

    console.table(filtered);
    return filtered;
  };
};
